import { Component, OnInit, ViewChild } from '@angular/core';
import { Model } from 'survey-core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

declare const $: any;

import { BaseComponent } from '../../modules/shared/base.component';
import { CreateResponseDto, Questionnaire } from '../../services/gpt/types';

import { GptService } from '../../services/gpt/gpt.service';
import { SelectedSubscriberService } from '../../services/selected-subscriber/selected-subscriber.service';
import { User } from '../../../types';

@Component({
  selector: 'app-follow-up-page',
  templateUrl: './follow-up-page.component.html',
  styleUrls: ['./follow-up-page.component.css'],
})
export class FollowUpPageComponent extends BaseComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  questionnaires: Questionnaire[] = [];
  pageNo: number = 0;
  limit: number = 10;
  totalRecords: number;
  displayedColumns: string[] = [
    'title',
    'requesterName',
    'createdAt',
    'answeredAt',
    'action',
  ];
  surveyModel: Model;
  dataSource: MatTableDataSource<any>;
  currentSelected: Questionnaire;
  currentSort: { by: string; order?: 'ASC' | 'DESC' };
  subscriberId: number;

  error: string;
  isLoading: boolean;

  constructor(
    private gptService: GptService,
    private selectedSubscriberService: SelectedSubscriberService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscriberId = this.selectedSubscriberService.user?.id;

    this.currentSort = {
      by: 'createdAt',
      order: 'DESC',
    };

    this.getQuestionnaires();
  }

  getQuestionnaires() {
    this.isLoading = true;
    this.error = '';
    this.subscriptions.add(
      this.gptService
        .getQuestionnaires({
          pageOffset: this.pageNo,
          pageSize: this.limit,
          sortField: this.currentSort.by,
          sortOrder: this.currentSort.order,
        })
        .subscribe(
          (data) => {
            this.totalRecords = data.totalCount;
            this.questionnaires = data.results || [];
            this.isLoading = false;
          },
          (error) => {
            this.error = error.message;
            this.isLoading = false;
          }
        )
    );
  }

  goToPage(newPageNumber: number) {
    this.pageNo = newPageNumber;
    this.getQuestionnaires();
  }

  uploadAnswer(data: Record<string, any>) {
    const answer: CreateResponseDto = {
      questionnaireId: this.currentSelected.id,
      answers: {
        answers: Object.keys(data).map((key) => {
          return {
            name: key,
            value: data[key],
          };
        }),
      },
    };

    this.subscriptions.add(
      this.gptService.createResponse(answer).subscribe(
        () => {
          this.getQuestionnaires();
          this.closeModal();
        },
        (error) => {
          this.error = error.message;
          this.closeModal();
        }
      )
    );
  }

  viewSubmissionForm(data: Questionnaire) {
    this.currentSelected = data;
    $('#open-question').modal('show');
    const survey = new Model(this.currentSelected.questionnaireSchema);
    survey.onComplete.add((sender, options) => {
      this.uploadAnswer(sender.data);
    });
    this.surveyModel = survey;
  }

  viewAnswerForm(data: Questionnaire) {
    const survey = new Model(data.questionnaireSchema);
    survey.data = data.response?.answers.answers.reduce(
      (prev, next) => ({ ...prev, [next.name]: next.value }),
      {}
    );
    survey.mode = 'display';
    this.surveyModel = survey;
    $('#open-question').modal('show');
  }

  closeModal() {
    $('#open-question').modal('hide');
  }

  getFullName(user?: User): string {
    if (user?.userProfile) {
      return `${user.userProfile.firstName} ${user.userProfile.lastName}`;
    }
    return '';
  }

  sortData(event: any) {
    let order: 'ASC' | 'DESC';

    switch (event.direction) {
      case 'asc': {
        order = 'ASC';
        break;
      }
      case 'desc': {
        order = 'DESC';
        break;
      }
      default:
        break;
    }

    this.pageNo = 0;
    this.currentSort = { by: order ? event.active : '', order };
    this.getQuestionnaires();
  }

  goToPreviousPage() {
    this.pageNo--;
    this.getQuestionnaires();
  }

  goToNextPage() {
    this.pageNo++;
    this.getQuestionnaires();
  }

  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    return Array(totalPages)
      .fill(0)
      .map((_, i) => i);
  }

  getTotalPages(): number {
    return this.totalRecords ? Math.ceil(this.totalRecords / this.limit) : 0;
  }

  deleteResponse(data: Questionnaire) {
    this.isLoading = true;
    this.subscriptions.add(
      this.gptService.deleteResponse(data.response.id).subscribe(
        () => {
          this.getQuestionnaires();
        },
        (error) => {
          this.error = error.message;
          this.isLoading = false;
        }
      )
    );
  }
}
